import { render, staticRenderFns } from "./ChecklistSectionsIndex.vue?vue&type=template&id=5b9a70fb"
import script from "./ChecklistSectionsIndex.vue?vue&type=script&lang=js"
export * from "./ChecklistSectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./ChecklistSectionsIndex.vue?vue&type=style&index=0&id=5b9a70fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports